import { isLegacyServiceAgentSSEEvent, fromLegacyServiceAgentSessionEvent, fromLegacyServiceAgentSessionSSEEvent } from "./sessions.events.legacy";
import { snakeToCamelCaseObject } from "../../utils";
/**
 * Type guard to determine if a given raw SSE payload is an error.
 */
export const isAgentSSEError = (d) => "error" in d && typeof d.error === "string";
/**
 * Type guard to determine if a given raw event is a legacy event. Legacy events carry a string
 * `timestamp` (ISO) or a string `content`; ADK events use a numeric `timestamp` and a structured
 * `content` object, so the string shapes are a reliable discriminant. Anything that isn't a legacy
 * shape falls through to being treated as ADK.
 */
function isLegacyServiceAgentSessionEvent(event) {
    return (event &&
        typeof event === "object" &&
        (("timestamp" in event && typeof event.timestamp === "string") ||
            ("content" in event && typeof event.content === "string")));
}
/**
 * Converts a raw service event (legacy REST, legacy SSE, or ADK) into the canonical
 * {@link AgentSessionEvent} shape. Dispatches on shape: legacy SSE chunks are detected via
 * {@link isLegacyServiceAgentSSEEvent}, legacy REST events via {@link isLegacyServiceAgentSessionEvent}
 * (string `timestamp`/`content`), and everything else is treated as an ADK event.
 */
export function agentSessionEventFromService(serviceEvent) {
    if (isLegacyServiceAgentSSEEvent(serviceEvent)) {
        return fromLegacyServiceAgentSessionSSEEvent(serviceEvent);
    }
    if (isLegacyServiceAgentSessionEvent(serviceEvent)) {
        return fromLegacyServiceAgentSessionEvent(serviceEvent);
    }
    // The BE has inconsistent casing for keys, so we normalize the top-level ADK envelope to camelCase.
    const event = snakeToCamelCaseObject(serviceEvent);
    return {
        id: event.id,
        // ADK's `author` is always the literal "user" or an agent name, never a username/email.
        author: event.author,
        role: event.author === "user" ? "user" : "model",
        content: {
            parts: (event.content?.parts ?? []),
            role: event.content?.role
        },
        // ADK sends seconds (with sub-second precision); convert to milliseconds for consistency with
        // Date.getTime(). A missing/non-numeric timestamp would otherwise produce NaN.
        timestamp: typeof event.timestamp === "number" ? event.timestamp * 1000 : Date.now(),
        partial: event.partial,
        errorMessage: event.errorMessage,
        ...(typeof event.turnComplete === "boolean" && { turnComplete: event.turnComplete }),
        ...(typeof event.turnCompleteReason === "string" && {
            turnCompleteReason: event.turnCompleteReason
        })
    };
}
//# sourceMappingURL=sessions.events.js.map